import React from 'react';
import { Box, Card, Typography, styled } from '@mui/material';
import { NotificationsActiveOutlined } from '@mui/icons-material';
import { ReactComponent as PillIcon } from 'assets/icons/PillIcon.svg';
import { radius } from 'themes/radius';
import { SvgIcon } from '../SvgIcon/SvgIcon';

export type ProfileReminderCardProps = {
  title: string;
  subtitle: string;
  /** `medication` shows the leading pill icon; `health` shows text only. */
  variant: 'medication' | 'health';
};

const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  padding: theme.spacing(2, 2),
  borderRadius: radius.card,
  backgroundColor: theme.palette.background.paper,
  boxShadow: `0 1px 2px 0 ${theme.palette.grey[400]}`,
}));

const TextBlock = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
  overflowWrap: 'anywhere',
});

const PillIconStyled = styled(SvgIcon)({
  flexShrink: 0,
});

const BellIcon = styled(NotificationsActiveOutlined)({
  flexShrink: 0,
});

export const ProfileReminderCard: React.FC<ProfileReminderCardProps> = ({
  title,
  subtitle,
  variant,
}) => (
  <StyledCard className="profile-reminder-card" elevation={0}>
    {variant === 'medication' && (
      <PillIconStyled
        className="profile-reminder-card__icon"
        component={PillIcon}
        color="secondary"
        fontSize="small"
        inheritViewBox
        aria-hidden
      />
    )}

    <TextBlock>
      <Typography className="profile-reminder-card__title" variant="callout" color="grey.800">
        {title}
      </Typography>
      <Typography
        className="profile-reminder-card__subtitle"
        variant="subheadline"
        color="grey.800"
      >
        {subtitle}
      </Typography>
    </TextBlock>

    <BellIcon
      className="profile-reminder-card__bell"
      color="secondary"
      fontSize="medium"
      aria-hidden
    />
  </StyledCard>
);
